export const Create = {
  FilesToUpload: "filesToUpload" as const,
  Date: "date" as const,
  SalesItems: "salesItems" as const,
  PaymentItems: "paymentItems" as const,
  OtherItems: "otherItems" as const,
  Dimensions: "dimensions" as const,
  HasRowLevelDimensions: "hasRowLevelDimensions" as const,
  SalesTotalAmount: "salesTotalAmount" as const,
  PaymentsTotalAmount: "paymentsTotalAmount" as const,
  OthersTotalAmount: "othersTotalAmount" as const,
  Total: "total" as const,
}

export const CashReconciliationItem = {
  TemplateItemId: "templateItemId" as const,
  Account: "account" as const,
  AccountType: "accountType" as const,
  Description: "description" as const,
  Amount: "amount" as const,
  Dimensions: "dimensions" as const,
  Category: "category" as const,
}

export const Filter = {
  SaleAmount: "saleAmount" as const,
  DifferenceAmount: "differenceAmount" as const,
  Date: "date" as const,
  RegisteredBy: "registeredBy" as const,
  RegisteredById: "registeredById" as const,
  Dimensions: "dimensions" as const,
}

